import React, { createContext, useContext, useState } from 'react';
import PlayerProfile from '../components/PlayerProfile';

const PlayerProfileContext = createContext();

export const usePlayerProfile = () => {
  const context = useContext(PlayerProfileContext);
  if (!context) {
    throw new Error('usePlayerProfile must be used within a PlayerProfileProvider');
  }
  return context;
};

export const PlayerProfileProvider = ({ children }) => {
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [leagueId, setLeagueId] = useState(null);

  const openPlayerProfile = (player, leagueIdParam = null) => {
    setSelectedPlayer(player);
    setLeagueId(leagueIdParam);
    setIsOpen(true);
  };

  const closePlayerProfile = () => {
    setIsOpen(false);
    setSelectedPlayer(null);
    setLeagueId(null);
  };

  return (
    <PlayerProfileContext.Provider
      value={{
        openPlayerProfile,
        closePlayerProfile,
        selectedPlayer,
        isOpen
      }}
    >
      {children}
      <PlayerProfile
        player={selectedPlayer}
        isOpen={isOpen}
        onClose={closePlayerProfile}
        leagueId={leagueId}
      />
    </PlayerProfileContext.Provider>
  );
};
